import axios from 'axios';
import { getApiUrl } from '~/api';
import { getAuthToken } from '~/auth';

export const apiRequest = async <T>({
  path,
  data,
}: {
  path: string;
  data: unknown;
}) => {
  const url = getApiUrl(path);
  const token = await getAuthToken();
  const result = await axios({
    url,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data,
  });

  return result.data as T;
};
